import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Intro from "@/components/Intro";
import Philosophy from "@/components/Philosophy";
import Founder from "@/components/Founder";
import Sectors from "@/components/Sectors";
import PreOpening from "@/components/PreOpening";
import Advisory from "@/components/Advisory";
import Experience from "@/components/Experience";
import GlobalNetwork from "@/components/GlobalNetwork";
import Tiers from "@/components/Tiers";
import Employers from "@/components/Employers";
import Candidates from "@/components/Candidates";
import CurrentlySeeking from "@/components/CurrentlySeeking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ConversationModal from "@/components/Conversation";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Intro />
      <Philosophy />
      <Founder />
      <Sectors />
      <PreOpening />
      <Advisory />
      <Experience />
      <GlobalNetwork />
      <Tiers />
      <Employers />
      <Candidates />
      <CurrentlySeeking />
      <Contact />
    </main>
    <Footer />
    <WhatsAppButton />
    <ConversationModal />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0E1A2B",
            color: "#F5F2EB",
            border: "1px solid rgba(200,163,91,0.4)",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
            fontSize: "13px",
          },
        }}
      />
    </div>
  );
}

export default App;
